import { z } from 'zod';
import LangEnum from '../../../lang/LangEnum';
import { isStartDateBeforeEndDate } from '../../../utils/schemaUtils/validateIsStartDateBeforeEndDate.utils';
import { TranslateType } from '../../translation/translationContext.types';

export const buildCatalogCreationAccessAddSchema = (translate: TranslateType) =>
  z
    .object({
      entityIds: z.array(z.string()),
      startDate: z.date(translate(LangEnum.GLOBAL_INVALID_DATE)).nullable(),
      endDate: z.date(translate(LangEnum.GLOBAL_INVALID_DATE)).nullable(),
    })
    .superRefine((values, ctx) => {
      if (isStartDateBeforeEndDate({ startDate: values.startDate, endDate: values.endDate })) {
        return;
      }

      ctx.addIssue({
        code: 'custom',
        path: ['endDate'],
        message: translate(LangEnum.GLOBAL_END_DATE_ERROR),
      });
    });

export type CatalogCreationAccessAddFormValues = z.infer<
  ReturnType<typeof buildCatalogCreationAccessAddSchema>
>;
